import { memo } from "react"

import { THEME } from "@/3514/theme"

type Props = {
    className?: string
    fillColor?: string
}

const AddIconSvg = ({ className, fillColor = THEME.COLORS.accentOld }: Props) => {
    return (
        <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <rect x="0.5" width="20" height="20" rx="10" fill={fillColor} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.66669 10.8333V15.3333H11.3334V10.8333H15.8334V9.16663H11.3334V4.66663H9.66669V9.16663H5.16669V10.8333H9.66669Z"
                fill="white"
            />
        </svg>
    )
}

export default memo(AddIconSvg)
